import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'autocomplete'
})
export class AutocompletePipe implements PipeTransform {

  transform(value: any, arg: any, type: string): any {
    let resultadoSearch: any = [];
    if (value !== undefined && value !== null) {
      const busquedaLimpia = arg.trim();
      switch (type) {

        case 'text':
          const subcadenas = busquedaLimpia.toLowerCase().split(' ');
          const primeraPalabra = subcadenas[0];

          // Crear un arreglo de objetos con el elemento (grupo) y su número de coincidencias (palabras)
          const elementosConCoincidencias = value.map(array => {
            // Contar cuántas palabras están presentes en el elemento (grupo)
            const coincidencias = subcadenas.filter(subcadena =>
              array.toLowerCase().includes(subcadena)
            ).length;

            return { elemento: array, coincidencias };
          });

          // Filtrar elementos que tengan al menos una coincidencia
          const elementosFiltrados = elementosConCoincidencias.filter(
            item => item.coincidencias > 0
          );

          // Ordenar los elementos por número de coincidencias (de mayor a menor)
          elementosFiltrados.sort((a: any, b: any) => b.coincidencias - a.coincidencias);

          // Ordenar los elementos por la primera palabra
          elementosFiltrados.sort((a: any, b: any) => {
            const aComienza = a.elemento.toLowerCase().startsWith(primeraPalabra);
            const bComienza = b.elemento.toLowerCase().startsWith(primeraPalabra);

            if (aComienza && !bComienza) return -1; // `a` primero
            if (!aComienza && bComienza) return 1;  // `b` primero
            return 0; // Mantener el orden original
          });

          // Guardar solo los elementos (sin el número de coincidencias)
          resultadoSearch = elementosFiltrados.map(item => item.elemento);

          return resultadoSearch;

        case 'categoria':
          for (const array of value) {
            if (array.departamento.toLowerCase().indexOf(busquedaLimpia.toLowerCase()) > - 1) {
              resultadoSearch.push(array);
            }
          }
          return resultadoSearch;
        case 'marca':
          for (const array of value) {
            if (array.Nombre.toLowerCase().indexOf(arg.toLowerCase()) > - 1) {
              resultadoSearch.push(array);
            }
          }
          return resultadoSearch;
      }
    }
  }
}
